import { readLabels } from './read'

export const labels = {
  readCollection: readLabels,
}
